import isPublicView from "app/utils/publicViewUtils";
import { Component } from "react";
import { IconArrowUp } from "../Icon/Icon";
import "./ScrollToTop.scss";

class ScrollToTop extends Component {
  scrollToTop = () => {
    // opted to use document.getElement because doing it any other way will not work
    // this component on click will scroll the user to the top
    // of a div called "List".
    const parentContainer = document.getElementsByClassName("List")[0];
    if (parentContainer) {
      parentContainer.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  render() {
    return (
      <div
        className={`${
          isPublicView() ? "scroll-to-top public-view" : "scroll-to-top"
        } `}
        onClick={this.scrollToTop}
      >
        <IconArrowUp />
      </div>
    );
  }
}

export default ScrollToTop;
